// extracted by mini-css-extract-plugin
module.exports = {"button":"LFoeu","active":"V6x75"};